

import React from 'react';
import { MOBILE_API_DOCUMENTATION } from 'redux/lib/constants/api-urls';
import MainComponent from './main-component';

const MobileApiDocumentation = (props) => {
    return (
        <MainComponent url={`${MOBILE_API_DOCUMENTATION.URL}`} />
    );
};
export default MobileApiDocumentation;


